import { PureComponent } from 'react';
import * as React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { DisplayTermStatus } from '../../constants/termStatus';
import { Tooltip } from '@cimpress/react-components';

export class TableCards extends PureComponent {
  onClearFilter = () => {
    const { onClickFilterCard } = this.props;
    onClickFilterCard('');
  };

  onFilterPendingApproval = () => {
    const { onClickFilterCard } = this.props;
    onClickFilterCard(DisplayTermStatus.PENDING_APPROVAL);
  };

  onFilterActionItems = () => {
    const { onClickFilterCard } = this.props;
    onClickFilterCard(DisplayTermStatus.AWAITING_YOUR_RESPONSE);
  };

  render() {
    const { t, data, filter } = this.props;

    const statusGroups = data.reduce((map, t) => {
      if (t.previousRevision) {
        map[t.previousRevision.displayStatus] = !map[t.previousRevision.displayStatus]
          ? [t.previousRevision]
          : [...map[t.previousRevision.displayStatus], t.previousRevision];
      }
      map[t.displayStatus] = !map[t.displayStatus] ? [t] : [...map[t.displayStatus], t];
      return map;
    }, {});

    const numberOfTerms = data.length;
    const pendingApprovalTerms = statusGroups[DisplayTermStatus.PENDING_APPROVAL] || [];
    const awaitingResponseTerms = statusGroups[DisplayTermStatus.AWAITING_YOUR_RESPONSE] || [];

    const cardsData = [
      {
        title: t('tableCards:allContracts'),
        text: numberOfTerms,
        isActive: !filter,
        onClick: this.onClearFilter
      },
      {
        title: t('tableCards:needsReview'),
        text: awaitingResponseTerms.length,
        isActive: filter === DisplayTermStatus.AWAITING_YOUR_RESPONSE,
        onClick: this.onFilterActionItems
      },
      {
        title: t('tableCards:pendingApproval'),
        text: pendingApprovalTerms.length,
        isActive: filter === DisplayTermStatus.PENDING_APPROVAL,
        onClick: this.onFilterPendingApproval
      }
    ];

    const cardsToRender = cardsData.map((d, idx) => {
      const card = (
        <div
          className={`card ${d.onClick ? 'clickable' : 'not-clickable'} ${d.isActive ? 'activeCard' : ''}`}
          onClick={d.onClick}>
          <div className="card-block">
            <h6 className="card-title">
              {d.title} {d.tooltip && <i className="fa fa-question-circle" />}
            </h6>
            <p className="card-text">{d.text}</p>
          </div>
        </div>
      );

      if (d.tooltip) {
        return (
          <Tooltip contents={d.tooltip} containerClassName="card-holder" key={idx}>
            {card}
          </Tooltip>
        );
      }

      return (
        <div className="card-holder" key={idx}>
          {card}
        </div>
      );
    });

    return <div className="card-deck table-cards">{cardsToRender}</div>;
  }
}

TableCards.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  filter: PropTypes.string.isRequired,
  onClickFilterCard: PropTypes.func.isRequired
};

export default withTranslation()(TableCards);
